import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'warning' | 'danger' | 'info';
  show: boolean;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type, 
  show, 
  onClose, 
  autoClose = true, 
  duration = 4000 
}) => {
  useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, autoClose, duration, onClose]);

  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return '✓';
      case 'warning': return '⚠';
      case 'danger': return '✕';
      case 'info': return 'ℹ';
      default: return '';
    }
  };

  return (
    <div 
      className="position-fixed top-0 start-50 translate-middle-x mt-3" 
      style={{ zIndex: 1055 }}
    >
      <div className={`alert alert-${type} alert-dismissible fade show d-flex align-items-center`} role="alert">
        <span className="me-2">{getIcon()}</span>
        <span>{message}</span>
        <button 
          type="button" 
          className="btn-close" 
          onClick={onClose}
          aria-label="Close"
        />
      </div>
    </div>
  );
};

export default Toast;
